import React, { Component } from 'react';

import * as propTypes from 'lib/prop_types';

import * as ProjectConstants from '../project_constants';

import { DeviceRequirementsDetails } from './device_requirements_details';
import { InPersonInterviewInfo } from './in_person_interview_info';
import { PhoneInterviewInfo } from './phone_interview_info';

export class ProjectInterviewInfo extends Component {
  static propTypes = {
    interviewInfo: propTypes.object.isRequired,
    interviewTypeId: propTypes.number.isRequired,
  };

  renderInterviewTypeComponent() {
    switch (this.props.interviewTypeId) {
      case ProjectConstants.INTERVIEW_TYPE_IN_PERSON.id:
        return <InPersonInterviewInfo {...this.props} />;
      case ProjectConstants.INTERVIEW_TYPE_PHONE.id:
        return (
          <PhoneInterviewInfo
            researcherWillCall={this.props.interviewInfo.researcherWillCall}
          />
        );
      default:
        return null;
    }
  }

  render() {
    return (
      <>
        {this.renderInterviewTypeComponent()}

        <DeviceRequirementsDetails
          deviceRequirements={this.props.interviewInfo.deviceRequirements}
          deviceSentence={this.props.interviewInfo.deviceSentence}
        />
      </>
    );
  }
}
